const imageClassificationLinks = {
  photoPreparationDoc:
    'https://datamermaid.org/documentation/image-classification-photos-preparation',
}
export default imageClassificationLinks

export const links = {
  contactUs: 'https://datamermaid.org/contact-us',
  reefCoverClassDefinitions:
    'https://reefresilience.org/wp-content/uploads/REEF-COVER-CLASS-DEFINITIONS.pdf',
  tideIntroduction: 'https://oceanservice.noaa.gov/education/tutorial_tides/tides01_intro.html',
  fishBaseLink: 'https://fishbase.mnhn.fr/search.php',
  allenCoralAtlas: 'https://allencoralatlas.org/atlas',
  gfcrToolkitPdf: `https://public.datamermaid.org/GFCR-Monitoring-and-Evaluation-Toolkit.pdf?nocache=${Date.now()}`,
  twoXChallengeCriteria: 'https://www.2xchallenge.org/2xcriteria',
  latLongDecimalDegrees: 'https://www.latlong.net/degrees-minutes-seconds-to-decimal-degrees',
  reefTypes:
    'https://www.livingoceansfoundation.org/wp-content/uploads/2015/04/U10-Reef-Types-complete-teacher.pdf',
  reefZonation:
    'https://www.livingoceansfoundation.org/wp-content/uploads/2015/04/U11-Reef-Zonation-Background.pdf',
}

export const internalNavigation = {
  projectStartPage: (projectId) => `/projects/${projectId}/project-info`,
}
